<template>
  <div style="height: 120px">
    <dv-border-box-6 :color="['#96e1fd', '#4ebee7']">
      <div style="padding: 10px 15px 10px 15px">
        <el-carousel interval="5000" height="110px">
          <el-carousel-item>
            <div>
              <div
                style="
                  color: #b3b3b3;
                  font-size: 14px;
                  font-weight: bold;
                  line-height: 150%;
                "
              >
                杨晓虎主持召开2023年长丰县赤霉病统防统治工作会议
              </div>
              <div style="color: #acacac; font-size: 13px">
                <div>
                  3月16日下午长丰县召开赤霉病统防统治工作布置暨作业机手培训会议，全县农技人员、村干部、统防统治植保组织及作业机手、种植户代表等100多人在县农业技术推广中心参加线下培训。会议由县农业农村局党委委员杨晓虎主持。
                </div>
                <div>
                  县农业技术推广中心分管领导，给大家详细讲解了2023年赤霉病统防统治项目乡村分片网格化管理办法。
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>
              <div
                style="
                  color: #b3b3b3;
                  font-size: 14px;
                  font-weight: bold;
                  line-height: 150%;
                "
              >
                长丰草莓专场推介活动服务采购中标候选人公示
              </div>
              <div style="color: #acacac; font-size: 13px">
                <div>
                  项目名称：安徽名优农产品暨农业产业化交易会（2023·上海）长丰草莓专场推介活动服务采购项目
                </div>
                <div>招标方式：公开招标 公告发布日期：2023年3月2日</div>
                <div>开标日期：2023年3月8日</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </dv-border-box-6>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/market-zone/policy-carousel.vue